import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  Loading,
  SetDefaultWarehouseDialog,
  ScreenMask,
} from 'components/common';
import {
  //COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
  //COMMON_MSG_DEFAULT_DISPLAY_DURATION,
  //HTTP_STATUS_OK,
  LOADING_ICON_SIZE1,
  LS_DEFAULT_WAREHOUSE_KEY,
} from 'constants/config';
import { RootState } from 'reducers';
import {
  SmartBackButton,
  SmartSpace,
} from '../SmartComponent';
import ScanBatch from './ScanBatch';
import ScanLocation from './ScanLocation';
import ScanSku from './ScanSku';
import {
  WHTActionType as WHTAction,
  WMSRecvStep,
  initialState,
  reducer,
} from './context';
import { getWarehouseCodeFromCache } from 'utils';

//const DefaultStep = WMSRecvStep.ScanBatch;

const getStateFromStorage = () => {
  const state: StringKAnyVPair = {};

  return state;
};

const WMSReceive = () => {
  const { useReducer, useState } = React;
  const [defaultWarehouseVisible, setDefaultWarehouseVisible] = useState(false);
  const [dialogClosable, setDialogClosable] = React.useState(true);
  const [inited, setInited] = useState(false);

  const warehouseList = useSelector(
    (state: RootState) => state.admin.warehouses,
    shallowEqual
  );

  const history = useHistory();
  const [state, dispatch] = useReducer(reducer, initialState(getStateFromStorage()));

  const onPageBack = () => {
    switch(state.wmsRecvStep) {
      case WMSRecvStep.ScanBatch:
        history.push('/smart/wh-transfer');
      break;

      case WMSRecvStep.ScanLocation:
        dispatch({ type: WHTAction.SetWMSRecvStep, params: WMSRecvStep.ScanBatch });
      break;

      case WMSRecvStep.ScanSku:
        dispatch({ type: WHTAction.SetWMSRecvStep, params: WMSRecvStep.ScanLocation });
      break;
    }
  };

  const openSetDefaultWarehouseDialog = (config: StringKAnyVPair) => {
    setDialogClosable(
      typeof config.closable === 'boolean' ? config.closable : true
    );
    setDefaultWarehouseVisible(true);
  };

  React.useEffect(() => {
    if (!inited) {
      const whid = Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY));

      if (!whid || (typeof whid === 'number' && !getWarehouseCodeFromCache(whid))) {
        openSetDefaultWarehouseDialog({ closable: false });
      }

      const wh = warehouseList.find(w => w.id === whid);

      if (wh) {
        dispatch({ type: WHTAction.SetSelectedWarehouse, params: {...wh} });
      }

      //gotoAnchor(PoRecvStep.ScanPo);
      setInited(true);
    }
  }, [inited, warehouseList]);

  return (<>
    <div style={{ marginTop: 10 }}>
      {state.wmsRecvStep === WMSRecvStep.ScanBatch && (
        <ScanBatch
          dispatch={dispatch}
          state={state}
        />
      )}
      {state.wmsRecvStep === WMSRecvStep.ScanLocation && (
        <ScanLocation
          dispatch={dispatch}
          state={state}
        />
      )}
      {state.wmsRecvStep === WMSRecvStep.ScanSku && (
        <ScanSku
          dispatch={dispatch}
          state={state}
        />
      )}
    </div>
    <SmartSpace>
      <SmartBackButton
        //onClick={() => history.goBack()}
        onClick={onPageBack}
      />
    </SmartSpace>
    {defaultWarehouseVisible && (
      <SetDefaultWarehouseDialog
        closable={dialogClosable}
        close={() => {
          setDefaultWarehouseVisible(false);
        }}
        visible={defaultWarehouseVisible}
      />
    )}
    {state.lockScreen && (
      <ScreenMask>
        <Loading size={LOADING_ICON_SIZE1} />
      </ScreenMask>
    )}
  </>);
};

export default WMSReceive;

export const isLineItemCode = (line: StringKAnyVPair, lc: string) => {
  const code = lc.trim();

  return code && line.sku === code;
};
